(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-diagnosis-quiz-template"]) return;
  try {
    
(function () {
  var root = document.getElementById('DiagnosisQuiz');
  if (!root) return;

  var steps = root.querySelectorAll('.DiagnosisQuiz__Step');
  var answers = { item: '', cut: '', budget: '' };

  function showStep(n) {
    for (var i = 0; i < steps.length; i++) {
      steps[i].hidden = (steps[i].getAttribute('data-step') !== String(n));
    }
  }

  function checkedValue(name) {
    var input = root.querySelector('input[name="' + name + '"]:checked');
    return input ? input.value : '';
  }

  function collectionPath() {
    var path = '/collections/' + answers.item;
    if (answers.cut) {
      path += '/' + encodeURIComponent(answers.cut);
    }
    return path;
  }

  function toResizedImage(url, width) {
    if (!url) return '';
    return url.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, '_' + width + 'x$1$2');
  }

  function renderResults(products) {
    var resultsEl = root.querySelector('.DiagnosisQuiz__Results');
    resultsEl.innerHTML = '';

    products.slice(0, 6).forEach(function (p) {
      var price = Math.round(p.price_min / 100).toLocaleString('ja-JP');
      var img = toResizedImage(p.featured_image, 400);
      var card = document.createElement('a');
      card.className = 'DiagnosisQuiz__ResultCard';
      card.href = '/products/' + p.handle;

      var imageWrap = document.createElement('div');
      imageWrap.className = 'DiagnosisQuiz__ResultImage';
      var imgEl = document.createElement('img');
      imgEl.src = img;
      imgEl.alt = p.title;
      imgEl.loading = 'lazy';
      imageWrap.appendChild(imgEl);

      var titleEl = document.createElement('div');
      titleEl.className = 'DiagnosisQuiz__ResultTitle';
      titleEl.textContent = p.title;

      var priceEl = document.createElement('div');
      priceEl.className = 'DiagnosisQuiz__ResultPrice';
      if (window.Shopify && Shopify.country === 'JP') {
        var exclNum = Math.round(p.price_min / 100);
        priceEl.innerHTML = '¥' + exclNum.toLocaleString('ja-JP') + '〜 <span class="PriceDual__Label">税抜</span><br><span class="PriceDual__Incl">¥' + Math.round(exclNum * 1.1).toLocaleString('ja-JP') + '〜</span>';
      } else {
        priceEl.textContent = '¥' + price + '〜';
      }

      card.appendChild(imageWrap);
      card.appendChild(titleEl);
      card.appendChild(priceEl);
      resultsEl.appendChild(card);
    });
  }

  function runQuiz() {
    var resultStep = root.querySelector('.DiagnosisQuiz__Step--result');
    var emptyEl = root.querySelector('.DiagnosisQuiz__Empty');
    var viewAllLink = root.querySelector('[data-quiz-viewall]');

    resultStep.classList.add('is-loading');
    emptyEl.hidden = true;
    viewAllLink.setAttribute('href', collectionPath());

    fetch(collectionPath() + '?section_id=atpt_collection_api')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var match = text.match(/\{[\s\S]*\}/);
        if (!match) throw new Error('unexpected response');
        var data = JSON.parse(match[0]);
        var products = data.products || [];

        if (answers.budget) {
          var parts = answers.budget.split('-');
          var min = parts[0] ? parseInt(parts[0], 10) : 0;
          var max = parts[1] ? parseInt(parts[1], 10) : Infinity;
          products = products.filter(function (p) {
            var price = p.price_min / 100;
            return price >= min && price <= max;
          });
        }

        resultStep.classList.remove('is-loading');

        if (!products.length) {
          emptyEl.hidden = false;
          return;
        }

        renderResults(products);
      })
      .catch(function () {
        resultStep.classList.remove('is-loading');
        emptyEl.hidden = false;
      });
  }

  root.addEventListener('click', function (e) {
    var nextBtn = e.target.closest('[data-quiz-next]');
    if (nextBtn) {
      var step = nextBtn.closest('.DiagnosisQuiz__Step').getAttribute('data-step');
      if (step === '1') {
        answers.item = checkedValue('quiz-item');
        var errorEl = root.querySelector('.DiagnosisQuiz__Error');
        if (!answers.item) {
          errorEl.hidden = false;
          return;
        }
        errorEl.hidden = true;
        showStep(2);
      } else if (step === '2') {
        answers.cut = checkedValue('quiz-cut');
        showStep(3);
      }
      return;
    }

    var submitBtn = e.target.closest('[data-quiz-submit]');
    if (submitBtn) {
      answers.budget = checkedValue('quiz-budget');
      showStep(4);
      runQuiz();
      return;
    }

    var backBtn = e.target.closest('[data-quiz-back]');
    if (backBtn) {
      showStep(backBtn.getAttribute('data-quiz-back'));
      return;
    }

    if (e.target.closest('[data-quiz-restart]')) {
      window.location.reload();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-page"]) return;
  try {
    
(function () {
  var STORAGE_KEY = 'radiann_wishlist';
  var root = document.getElementById('WishlistPage');
  if (!root) return;

  var labelRemove = root.getAttribute('data-label-remove') || 'Remove';

  function readList() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function render() {
    var list = readList();
    var grid = root.querySelector('.WishlistPage__Grid');
    var empty = root.querySelector('.WishlistPage__Empty');
    grid.innerHTML = '';

    if (!list.length) {
      empty.hidden = false;
      return;
    }
    empty.hidden = true;

    list.forEach(function (item) {
      var card = document.createElement('div');
      card.className = 'WishlistPage__Card';

      var link = document.createElement('a');
      link.className = 'WishlistPage__Link';
      link.href = item.url || ('/products/' + item.handle);

      var imgWrap = document.createElement('div');
      imgWrap.className = 'WishlistPage__Image';
      var img = document.createElement('img');
      img.src = item.image;
      img.alt = item.title;
      img.loading = 'lazy';
      imgWrap.appendChild(img);

      var title = document.createElement('div');
      title.className = 'WishlistPage__Title';
      title.textContent = item.title;

      var price = document.createElement('div');
      price.className = 'WishlistPage__Price';
      /* item.price はテーマのmoney系フィルタ由来（自社Liquidが生成、外部入力ではない）で、
         Hextomアプリがmoney_format設定に仕込んだHTMLを含む場合があるため、
         textContentではなくinnerHTMLで挿入し他の価格表示と同じ見た目にする */
      price.innerHTML = item.price;

      link.appendChild(imgWrap);
      link.appendChild(title);
      link.appendChild(price);

      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'WishlistPage__Remove';
      removeBtn.textContent = labelRemove;
      removeBtn.addEventListener('click', function () {
        var current = readList().filter(function (i) { return i.id !== item.id; });
        writeList(current);
        document.dispatchEvent(new CustomEvent('wishlist:changed'));
      });

      card.appendChild(link);
      card.appendChild(removeBtn);
      grid.appendChild(card);
    });
  }

  render();
  document.addEventListener('wishlist:changed', render);
})();

  } catch(e) { console.error(e); }
})();
})();
